import { Component, OnInit, ChangeDetectorRef, ElementRef, Input, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivationEnd, ActivatedRoute } from '@angular/router';
import { ACLService } from '@delon/acl';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-tiktok-analyze',
  templateUrl: './tiktok-analyze.component.html',
  styleUrls: ['./tiktok-analyze.component.less'],
})
export class TiktokAnalyzeComponent implements OnInit, AfterViewInit {

static NAME = 'icc-msg-social-analyze';

  tiktokName: string;
  channelId: number;
  tiktokNum: string;

  private router$: Subscription;
  menus: any[] = [];
  mode = 'inline';

  title: string;
  constructor(private router: Router, private cdr: ChangeDetectorRef, private el: ElementRef, private aclService: ACLService, private route: ActivatedRoute) {
    // todo：先判断权限
    this.menus.push(
      {
        key: 'video',
        title: '视频分析',
      },
      {
        key: 'fans',
        title: '粉丝分析',
      },
    );
    //this.router$ = this.router.events.pipe(filter(e => e instanceof ActivationEnd)).subscribe(() => this.setActive());
  }

  ngAfterViewInit() {
    this.router$ = this.router.events.pipe(filter(e => e instanceof ActivationEnd)).subscribe(() => this.setActive());
  }

  private setActive() {
    let key = '';
    if (this.router.url.match(/analyze\/(\S*)\?/) !== null) {
      key = this.router.url.match(/analyze\/(\S*)\?/)[1];
    }
    let flag = true;
    for (let index = 0; index < this.menus.length; index++) {
      if (key === this.menus[index].key) {
        this.menus[index].selected = this.menus[index].key === key;
        flag = false;
      }
      if (index === this.menus.length - 1 && flag) {
        this.menus[index].selected = this.menus[0].key === key;
      }
    }
    if (this.menus.find(w => w.selected)) {
      this.title = this.menus.find(w => w.selected).title;
    }
  }

  to(item: any) {
    this.router.navigate([`/stat/social/tiktok/analyze/${item.key}`], { queryParams: { channelId: this.channelId, tiktokName: this.tiktokName, tiktokNum: this.tiktokNum } });
  }

  ngOnInit() {
    this.setActive();
    const params = this.route.snapshot.queryParams;
    this.channelId = params.channelId;
    this.tiktokName = params.tiktokName;
    this.tiktokNum = params.tiktokNum;
  }

  /** 返回 */
  goBack() {
    this.router.navigate(['/stat/social/tiktok/list']);
  }
}
